import { type Clip } from '@air/api/types';

import { PLACEHOLDER_IMAGE_BASE_NAME } from '~/components/ExportImagesModal/components/ExportImagesModalForm/components/ImageSuffixFormField';
import { type ExportImagesModalProps } from '~/components/ExportImagesModal/ExportImagesModal';
import { getClipDisplayTitle } from '~/utils/getClipDisplayTitle';
import { getBestImgixExportSource, isClipExportable } from '~/utils/Imgix';

export type ExportImagesModalPropsForClip = Pick<
  ExportImagesModalProps,
  'fileName' | 'height' | 'imageSrc' | 'width' | 'workspaceId'
>;

type GetExportImagesModalPropsForClipParams = {
  clip: Clip;
  workspaceId: string | undefined;
};

export const getExportImagesModalPropsForClip = ({
  clip,
  workspaceId,
}: GetExportImagesModalPropsForClipParams): ExportImagesModalPropsForClip | undefined => {
  if (!isClipExportable(clip)) {
    return undefined;
  }

  const imageSrc = getBestImgixExportSource(clip.ext, clip.assets);

  if (!imageSrc) {
    return undefined;
  }

  return {
    fileName: getClipDisplayTitle(clip, PLACEHOLDER_IMAGE_BASE_NAME),
    height: clip.height,
    imageSrc,
    width: clip.width,
    workspaceId,
  };
};
